import Vue from 'vue'
import VehicleTrackingTransformer from '@/transformers/VehicleTrackingTransformer'
const vehicleTrackingTransformer = new VehicleTrackingTransformer()

export const SET_DEVICES_INACTIVE = 'setDevicesInactive'
export const SET_DEVICES_ONLINE = 'setDevicesOnline'
export const SET_DEVICES_OFFLINE = 'setDevicesOffline'
export const SUBSCRIBE_TRACKING_VEHICLE = 'subscribeTrackingVehicle'
export const UNSUBSCRIBE_TRACKING_VEHICLE = 'unsubscribeTrackingVehicle'
export const CLEAR_TRACKING_VEHICLES = 'clearTrackingVehicles'
export const UPDATE_FILTERS = 'updateFilters'
export const CENTER_MAP_ON_CAR = 'centerMapOnCar'
export const SET_ACTIVE_JOURNEY = 'setActiveJourney'
export const SET_IS_JOURNEY_LOADING = 'setIsJourneyLoading'
export const SET_DEVICE_STATISTICS = 'setDeviceStatistics'
export const SUBSCRIBE_JOURNEY_VEHICLE = 'subscribeJourneyVehicle'
export const UNSUBSCRIBE_JOURNEY_VEHICLE = 'unsubscribeJourneyVehicle'
export const CLEAR_SUBSCRIBE_JOURNEY_VEHICLES = 'clearSubscriptionJourneyVehicles'
export const ADD_ACTIVE_JOURNEY = 'addActiveJourney'
export const REMOVE_ACTIVE_JOURNEY = 'removeActiveJourney'
export const CLEAR_ACTIVE_JOURNEYS = 'clearActiveJourneys'
export const SET_CURRENT_JOURNEY = 'setCurrentJourney'
export const UPDATE_CURRENT_JOURNEY_MEDIA = 'updateCurrentJourneyMedia'
export const SET_CURRENT_VEHICLE = 'setCurrentVehicle'
export const ADD_SELECTED_JOURNEY = 'addSelectedJourney'
export const REMOVE_SELECTED_JOURNEY = 'removeSelectedJourney'
export const CLEAR_SELECTED_JOURNEY = 'clearSelectedJourneys'
export const SET_SHOW_IDLE_POINTS = 'setShowIdlePoints'
export const SET_SHOW_RAW_DATA = 'setShowRawData'
export const SET_SHOW_SPEEDING_DATA = 'setShowSpeedingData'
export const SET_EVENT_FILTERS = 'setEventFilters'
export const SET_EVENT_CLASSIFICATION = 'setEventClassification'
export const SET_LOADING = 'setLoading'
export const SET_IS_TRACKING_ASIDE_LOADING = 'setIsTrackingAsideLoading'
export const SET_IS_JOURNEY_TAB_ACTIVE = 'setIsJourneyTabActive'
export const SET_OPEN_AUTO_JOURNEY = 'setOpenAutoJourney'
export const SET_DATE_IN_JOURNEY_TAB = 'setDateInJourneyTab'
export const SET_UPDATE_SHARED_EVENT = 'setUpdateSharedEvent'
export const UPDATE_SUBSCRIBED_VEHICLES_POSITIONS = 'updateSubscribedVehiclesPositions'
export const SET_IS_CLUSTERING_ACTIVE = 'setIsClusteringActive'
export const SET_IS_OPEN_ACTION_JOURNEY_TAB = 'setIsOpenActionJourneyTab'
export const SET_LAST_ACTIVE_DATE = 'setLastActiveDate'

const setDevicesInactive = (state, payload) => {
    state.devicesInactive = payload
}

const setDevicesOnline = (state, payload) => {
    state.devicesOnline = payload
}

const setDevicesOffline = (state, payload) => {
    state.devicesOffline = payload
}

const subscribeTrackingVehicle = (state, payload) => {

    const isSubscribed = state.trackingVehicles.find((elem) => {
        return elem.trackingHardwareId === payload.trackingHardwareId
    })

    if (null != isSubscribed) {
        return
    }

    if (null == state.subscribedVehiclesFleetCounter[payload.fleetId]) {
        Vue.set(state.subscribedVehiclesFleetCounter, payload.fleetId, 0)
    }

    state.subscribedVehiclesFleetCounter[payload.fleetId]++

    state.trackingVehicles.push(payload)
}

const unsubscribeTrackingVehicle = (state, payload) => {
    let { trackingVehicles } = state

    const indexOf = trackingVehicles.findIndex((elem) => {
        return elem.trackingHardwareId == payload.trackingHardwareId
    })

    if (-1 >= indexOf) {
        return
    }

    if (null == state.subscribedVehiclesFleetCounter[payload.fleetId]) {
        state.subscribedVehiclesFleetCounter[payload.fleetId] = 1
    }

    state.subscribedVehiclesFleetCounter[payload.fleetId]--

    state.trackingVehicles.splice(indexOf, 1)

}

const clearTrackingVehicles = (state, payload) => {
    state.trackingVehicles = []
    state.subscribedVehiclesFleetCounter = {}
}

const updateFilters = (state, payload) => {
    if (!state.filters.includes(payload)) {
        state.filters.push(payload)
    } else {
        let index = state.filters.indexOf(payload)
        state.filters.splice(index, 1)
    }
}

const centerMapOnCar = (state, payload) => {
    state.centerCar = payload
}

const setActiveJourney = (state, payload) => {
    state.activeJourney = payload
}

const setIsJourneyLoading = (state, payload) => {
    state.isJourneyLoading = payload
}

const setDeviceStatistics = (state, payload) => {
    state.deviceStatistics = payload
}

const subscribeJourneyVehicle = (state, payload) => {
    const isSubscribed = state.journeyVehicles.find((elem) => {
        return elem.trackingHardwareId === payload.trackingHardwareId
    })

    if (null != isSubscribed) {
        return
    }

    state.journeyVehicles.push(payload)
}

const unsubscribeJourneyVehicle = (state, payload) => {
    let { journeyVehicles } = state

    const indexOf = journeyVehicles.findIndex((elem) => {
        return elem.trackingHardwareId == payload.trackingHardwareId
    })

    if (-1 >= indexOf) {
        return
    }

    state.journeyVehicles.splice(indexOf, 1)
}

const clearSubscriptionJourneyVehicles = (state, payload) => {
    state.journeyVehicles = []
}

const addActiveJourney = (state, payload) => {
    const isSubscribed = state.activeJourneys.find((elem) => {
        return elem.vehicle.id === payload.vehicle.id
    })

    if (null != isSubscribed) {
        return
    }

    state.activeJourneys.push(payload)
}

const removeActiveJourney = (state, payload) => {
    let { activeJourneys } = state

    const indexOf = activeJourneys.findIndex((elem) => {
        return elem.vehicle.id === payload.vehicle.id
    })

    if (-1 >= indexOf) {
        return
    }

    state.activeJourneys.splice(indexOf, 1)
}

const clearActiveJourneys = (state, payload) => {
    state.activeJourneys = []
}

const setCurrentJourney = (state, payload) => {
    state.currentJourney = payload
}

const updateCurrentJourneyMedia = (state, payload) => {
    if (state.currentJourney) {
        state.currentJourney.medias = payload
    }
}

const setCurrentVehicle = (state, payload) => {
    state.currentVehicle = payload
}

const addSelectedJourney = (state, payload) => {
    const result = state.selectedJourneys.find((elem) => {
        return elem.id === payload.id
    })

    if (null != result) {
        return
    }

    state.selectedJourneys.push(payload)
}

const removeSelectedJourney = (state, payload) => {
    let { selectedJourneys } = state

    const indexOf = selectedJourneys.findIndex((elem) => {
        return elem.id === payload.id
    })

    if (process.env.VUE_APP_DEBUG) {
        console.debug('removeSelectedJourney', payload, indexOf)
    }

    if (-1 >= indexOf) {
        return
    }

    state.selectedJourneys.splice(indexOf, 1)
}

const clearSelectedJourneys = (state, payload) => {
    state.selectedJourneys = []
}

const setShowIdlePoints = (state, payload) => {
    state.showIdlePoints = payload
}

const setShowRawData = (state, payload) => {
    state.showRawData = payload
}

const setShowSpeedingData = (state, payload) => {
    state.showSpeedingData = payload
}

const setEventFilters = (state, payload) => {
    state.eventFilters = payload
}

const setEventClassification = (state, payload) => {
    state.eventClassifications = payload
}

const setLoading = (state, payload) => {
    state.isLoading = payload
}

const setIsTrackingAsideLoading = (state, payload) => {
    state.isTrackingAsideLoading = payload
}

const setIsJourneyTabActive = (state, payload) => {
    state.isJourneyTabActive = payload
}

const setOpenAutoJourney = (state, payload) => {
    state.openAutoJourney = payload
}

const setDateInJourneyTab = (state, payload) => {
    state.dateInJourneyTab = payload
}
const setUpdateSharedEvent = (state, payload) => {
    state.updatedSharedEvent = payload
}
const setIsClusteringActive = (state, payload) => {
    state.isClusteringActive = payload
}
const setIsOpenActionJourneyTab = (state, payload) => {
    state.isOpenActionJourneyTab = payload
}
const setLastActiveDate = (state, payload) => {
    state.lastActiveDate = payload
}

const updateSubscribedVehiclesPositions = (state, payload) => {
    payload.forEach(message => {
        const vehicleIndex = state.trackingVehicles.findIndex((item) => {
            return item.trackingHardwareId === message.hardId
        })

        if (-1 === vehicleIndex) {
            return
        }

        state.trackingVehicles[vehicleIndex].vehicleTracking = vehicleTrackingTransformer.transform(message)
    })
}

export default {
    setDevicesInactive,
    setDevicesOnline,
    setDevicesOffline,
    subscribeTrackingVehicle,
    unsubscribeTrackingVehicle,
    clearTrackingVehicles,
    updateFilters,
    centerMapOnCar,
    setActiveJourney,
    setIsJourneyLoading,
    setDeviceStatistics,
    subscribeJourneyVehicle,
    unsubscribeJourneyVehicle,
    clearSubscriptionJourneyVehicles,
    addActiveJourney,
    removeActiveJourney,
    clearActiveJourneys,
    setCurrentJourney,
    updateCurrentJourneyMedia,
    setCurrentVehicle,
    addSelectedJourney,
    removeSelectedJourney,
    clearSelectedJourneys,
    setShowIdlePoints,
    setShowRawData,
    setEventFilters,
    setEventClassification,
    setLoading,
    setIsTrackingAsideLoading,
    setIsJourneyTabActive,
    setOpenAutoJourney,
    setDateInJourneyTab,
    setShowSpeedingData,
    setUpdateSharedEvent,
    updateSubscribedVehiclesPositions,
    setIsClusteringActive,
    setIsOpenActionJourneyTab,
    setLastActiveDate
}
